import React, { useState } from "react";
import {
  ComposableMap,
  ZoomableGlobe,
  Geographies,
  Geography,
  Markers,
  Marker,
} from "react-simple-maps";
import { FaMapMarkerAlt } from "react-icons/fa";
// import { PatternLines } from "@vx/pattern";

const mapStyles = {
  width: "90%",
  margin: "0 auto",
  display: "block",
  height: "auto",
};

const markers = [
  { markerOffset: 0, name: "Pakistan", coordinates: [69.345116, 30.375321] },
  { markerOffset: 0, name: "Italy", coordinates: [12.56738, 41.87194] },
  { markerOffset: 0, name: "Australia", coordinates: [133.775136, -25.274398] },
  { markerOffset: 0, name: "Belgium", coordinates: [4.469936, 50.503887] },
  { markerOffset: 0, name: "Belize", coordinates: [-88.4976, 17.1899] },
  { markerOffset: 0, name: "Canada", coordinates: [-106.346771, 56.130366] },
  { markerOffset: 0, name: "China", coordinates: [104.195397, 35.86166] },
  { markerOffset: 0, name: "Denmark", coordinates: [9.501785, 56.26392] },
  { markerOffset: 0, name: "France", coordinates: [2.213749, 46.227638] },
  { markerOffset: 0, name: "Germany", coordinates: [10.451526, 51.165691] },
  { markerOffset: 0, name: "India", coordinates: [78.96288, 20.593684] },
  { markerOffset: 0, name: "Indonesia", coordinates: [113.921327, -0.789275] },
  { markerOffset: 0, name: "Japan", coordinates: [138.252924,36.204824] },
  { markerOffset: 0, name: "Thailand", coordinates: [100.992541,15.870032] },
  { markerOffset: 0, name: "Turkey", coordinates: [35.243322,38.963745] },
  { markerOffset: 0, name: "United Kingdom", coordinates: [-3.435973,55.378051] },
  { markerOffset: 0, name: "Zimbabwe", coordinates: [29.154857,-19.015438] },
  { markerOffset: 0, name: "Antartica", coordinates: [-0.071389,-75.250973] },
  { markerOffset: 0, name: "Benin", coordinates: [2.315834,9.30769] },
  { markerOffset: 0, name: "Bermuda", coordinates: [-64.75737,32.321384] },
    
];

const Map = () => {
  const [selectState, setSelectState] = useState();
  const handleClick = (geo) => () => {
    console.log(geo);
    setSelectState(geo?.name);
  };
  return (
    <div style={{ width: "100%" }}>
      <ComposableMap
        width={500}
        height={500}
        projection="orthographic"
        projectionConfig={{ scale: 220 }}
        style={mapStyles}
      >
        {/* <PatternLines
        id="lines"
        height={6}
        width={6}
        stroke="#776865"
        strokeWidth={1}
        background="#F6F0E9"
        orientation={["diagonal"]}
      /> */}
        <ZoomableGlobe>
          {/* <FaMapMarkerAlt /> */}
          <circle cx={250} cy={250} r={220} fill="#002740" stroke="#CFD8DC" />
          <Geographies
            disableOptimization
            geography="https://unpkg.com/world-atlas@1.1.4/world/110m.json"
          >
            {(geos, proj) =>
              geos.map((geo, i) => (
                <Geography
                  key={geo.id + i}
                  stroke="none"
                  fill={
                    selectState !== geo?.properties?.name
                      ? "#077e4e"
                      : "#c3c3c3"
                  }
                  geography={geo}
                  projection={proj}
                  // onClick={handleClick(geo.properties)}
                  // style={{
                  //   default: {
                  //     fill: "#CFD8DC",
                  //   },
                  // }}
                  style={{
                    default: { outline: "none", fill: "#077e4e" },
                    hover: { outline: "none" },
                    pressed: { outline: "none" },
                  }}
                />
              ))
            }
          </Geographies>
          <Markers>
            {markers.map((marker) => (
              <Marker
                marker={marker}
                onClick={handleClick(marker)}
                style={{
                  hidden: { display: "none" },
                }}
              >
                {/* <FaMapMarkerAlt cx={0} cy={0} r={6} fill="#cd5843" stroke="#FFF"/> */}
                {/* <div>{marker?.name}</div> */}
                {/* <circle cx={0} cy={0} r={6} fill="#FF5722" stroke="#FFF" /> */}
                {/* <text
                    textAnchor="middle"
                    y={marker?.markerOffset}
                    style={{ fontFamily: "system-ui", fill: "#5D5A6D" }}
                    >
                    {marker?.name}
                    </text> */}

                <g
                  fill="none"
                  stroke="#FF5533"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  transform="translate(-12, -24)"
                >
                  <circle cx="12" cy="10" r="3" />
                  <path d="M12 21.7C17.3 17 20 13 20 10a8 8 0 1 0-16 0c0 3 2.7 6.9 8 11.7z" />
                </g>
                <text
                  textAnchor="middle"
                  y={marker?.markerOffset}
                  style={{ fontFamily: "system-ui", fill: "#fff", fontSize: '8px' }}
                >
                  {marker?.name}
                </text>
              </Marker>
            ))}
          </Markers>
        </ZoomableGlobe>
      </ComposableMap>
    </div>
  );
};

export default Map;
